import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { SprayEventEntityId } from 'services/sprayEvents/types';
import { selectEntities } from 'services/entities/selectors';
import { selectVarieties } from 'services/varieties/selectors';
// @ts-ignore
import { makeSelectHarvestSchemaValue } from 'services/schemas/selectors';
import { getEntitiesOptionsWithVariety } from 'utils/events';
import { EntityDropdownOptions } from '../../types';
import { OwnProps } from './index';

const selectOptions = (
    state: AppState,
    props: OwnProps
): EntityDropdownOptions => props.options;

const selectSprayEntityId = (
    state: AppState,
    props: OwnProps
): SprayEventEntityId | undefined => props.sprayEntityId;

const selectSprayInnerEntityOptions = createDeepEqualSelector(
    selectOptions,
    selectEntities,
    selectVarieties,
    selectSprayEntityId,
    makeSelectHarvestSchemaValue('entityTypeId'),
    (options, entities, varieties, sprayEntityId, harvestEntityTypeId) => {
        if (!sprayEntityId) return [];

        return getEntitiesOptionsWithVariety(
            options,
            entities,
            varieties,
            sprayEntityId,
            harvestEntityTypeId
        );
    }
);

const makeSelectSprayInnerEntityOptions =
    (): typeof selectSprayInnerEntityOptions => selectSprayInnerEntityOptions;

export { makeSelectSprayInnerEntityOptions };
